module.exports = __webpack_public_path__ + "b809b24325654737121c7bda55972eea.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/korolev_medium-webfont.woff2
// module id = Yi8J
// module chunks = 0